import React, { useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Modal from 'components/Tvendo/Common/ModalBase';
import FilterArticle from 'hooks/FilterArticle';
import { wsGetAll } from 'services/WService.js';

export default function ModalMustHaveProduct(props) {
  const infaltable = props.model;
  const editando = !!infaltable?.id;

  const [bureaus, setBureaus] = useState([]);
  const [zones, setZones] = useState([]);
  const [zoneId, setZoneId] = useState(null);
  const [productId, setProductId] = useState(infaltable?.logi_product_id ?? null);
  const [bureauId, setBureauId] = useState(infaltable?.base_bureau_id ?? null);

  async function listBureaus() {
    const response = await wsGetAll('base/bureau');
    if (response.success) setBureaus(response.data);
  }

  async function listZones() {
    const response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    listBureaus();
    listZones();
  }, []);

  useEffect(() => {
    if (zoneId !== null || bureaus.length === 0 || bureauId === null) return;
    const mesa = bureaus.find((item) => item.id === bureauId);
    if (mesa) setZoneId(mesa.base_zone_id ?? null);
  }, [bureaus, bureauId, zoneId]);

  const mesasFiltradas = zoneId === null
    ? bureaus
    : bureaus.filter((item) => item.base_zone_id === zoneId);

  const zonaActual = zones.find((item) => item.id === zoneId) ?? null;
  const mesaActual = bureaus.find((item) => item.id === bureauId) ?? null;

  function cambiarZona(item) {
    const nueva = item?.id ?? null;
    setZoneId(nueva);
    if (nueva !== null && mesaActual && mesaActual.base_zone_id !== nueva) {
      setBureauId(null);
    }
  }

  return (
    <Modal
      title="Producto infaltable"
      model={infaltable}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="logi/must-have-product"
      state
      dataForce={{
        logi_product_id: productId,
        base_bureau_id: bureauId,
      }}
    >
      {editando ? (
        <TextField
          label="Producto"
          margin="normal"
          fullWidth
          disabled
          value={
            infaltable.product
              ? `${infaltable.product.ItemCode} - ${infaltable.product.ItemName}`
              : ''
          }
        />
      ) : (
        <FilterArticle
          fullWidth
          article
          mark
          reqField={['product']}
          getArticle={(item) => setProductId(item?.id ?? null)}
        />
      )}

      <GridContainer>
        <GridItem xs={12} md={5}>
          <Autocomplete
            options={zones}
            value={zonaActual}
            getOptionLabel={(option) => `${option.code} - ${option.description}`}
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Zona" margin="normal" />
            )}
            onChange={(e, item) => cambiarZona(item)}
          />
        </GridItem>
        <GridItem xs={12} md={7}>
          <Autocomplete
            options={mesasFiltradas}
            value={mesaActual}
            getOptionLabel={(option) => `${option.code} - ${option.description}`}
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Mesa" margin="normal" required />
            )}
            onChange={(e, item) => setBureauId(item?.id ?? null)}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} md={6}>
          <TextField
            label="Cantidad"
            type="number"
            name="quantity"
            margin="normal"
            fullWidth
            required
            defaultValue={infaltable?.quantity ?? 1}
            inputProps={{ min: 1 }}
          />
        </GridItem>
        <GridItem xs={12} md={6}>
          <TextField
            label="Prioridad"
            type="number"
            name="priority"
            margin="normal"
            fullWidth
            defaultValue={infaltable?.priority ?? ''}
            inputProps={{ min: 1 }}
          />
        </GridItem>
      </GridContainer>

      <TextField
        label="Autoselección desde"
        type="date"
        name="start_date"
        margin="normal"
        fullWidth
        required
        defaultValue={infaltable?.start_date ?? ''}
        InputLabelProps={{ shrink: true }}
      />
    </Modal>
  );
}
